import common from 'store/modules/common/api'

export const api = {
  ...common.softDeleteApiMethods('Grapes')
}
